import { SESSION_TIME_OUT_INTERVAL, LOCAL_STORAGE_CONSTANTS } from './index';

const {
  SESSION_TIME_OUT,
  USER_ID,
  TOKEN,
  ROLE,
  QUESTION_ATTRIBUTES,
  BUSINESS_ID,
  USER_INVITATION,
  DASHBOARD_METRICS,
  SIGNUP_CONTACT_DETAILS,
  SIGNUP_BUSINESS_DETAILS,
  ONBOARDING_STATUS,
  SQ_NONCE,
  BILLING_DETAILS,
  SELECTED_SUGGESTED_TEMPLATE,
  SELECTED_TEMPLATES,
  CONFIRMED,
  CONFIRMATION_GRACE_PERIOD,
  SELECTED_PLAN,
  PLAN_SUBSCRIPTION_STATUS,
  BUSINESS_PLAN,
  REDEEMED_VOUCHER_CODE,
  SET_USER_PLAN,
  USER_DATA,
} = LOCAL_STORAGE_CONSTANTS;

function saveToLocalStorage(name, value) {
  localStorage.setItem(name, value);
}

function getFromLocalStorage(name) {
  return localStorage.getItem(name);
}

function deleteFromLocalStorage(name) {
  localStorage.removeItem(name);
}

export function setDashboardMetricObject(object) {
  setObject(DASHBOARD_METRICS, object);
}

export function getDashboardMetricObject() {
  return getObject(DASHBOARD_METRICS);
}

export function setObject(objectName, object) {
  localStorage.setItem(objectName, JSON.stringify(object));
}

export function getObject(objectName) {
  const object = localStorage.getItem(objectName);
  return object !== 'undefined' ? JSON.parse(object) : {};
}

export function setSessionTimeOut() {
  const timeOutLimit = Date.now() + SESSION_TIME_OUT_INTERVAL;
  setObject(SESSION_TIME_OUT, timeOutLimit);
}

export function getSessionTimeOut() {
  return getObject(SESSION_TIME_OUT);
}
export function setUserId(uId) {
  saveToLocalStorage(USER_ID, uId);
}

export function setConfirmed(confirmed) {
  setObject(CONFIRMED, confirmed);
}

export function getConfirmed() {
  return getObject(CONFIRMED);
}

export function setConfirmationGracePeriod(data) {
  saveToLocalStorage(CONFIRMATION_GRACE_PERIOD, data);
}

export function getConfirmationGracePeriod() {
  return getFromLocalStorage(CONFIRMATION_GRACE_PERIOD);
}

export function setToken(token) {
  saveToLocalStorage(TOKEN, token);
}

export function getToken() {
  return getFromLocalStorage(TOKEN);
}

export function setRole(roleName) {
  saveToLocalStorage(ROLE, roleName);
}

export function setQuestionAttributes(questionAttributes) {
  setObject(QUESTION_ATTRIBUTES, questionAttributes);
}

export function setSuggestedTemplate(suggestedTemplate) {
  setObject(SELECTED_SUGGESTED_TEMPLATE, suggestedTemplate);
}

export function getRole() {
  return getFromLocalStorage(ROLE);
}

export function setBusinessId(businessId) {
  saveToLocalStorage(BUSINESS_ID, businessId);
}

export function getBusinessId() {
  return getFromLocalStorage(BUSINESS_ID);
}

export function setUserInvitation(userInvitation) {
  setObject(USER_INVITATION, userInvitation);
}

export function getUserInvitation() {
  return getObject(USER_INVITATION);
}

export function getUserId() {
  return getFromLocalStorage(USER_ID);
}

export function getQuestionAttributes() {
  return getObject(QUESTION_ATTRIBUTES);
}

export function removeQuestionAttributes() {
  deleteFromLocalStorage(QUESTION_ATTRIBUTES);
}

export function setSelectedTemplates(selectedTemplates) {
  setObject(SELECTED_TEMPLATES, selectedTemplates);
}

export function getSelectedTemplates() {
  return getObject(SELECTED_TEMPLATES);
}

export function removeSelectedTemplates() {
  deleteFromLocalStorage(SELECTED_TEMPLATES);
}

export function setContactDetails(value) {
  setObject(SIGNUP_CONTACT_DETAILS, value);
}

export function getContactDetails() {
  return getObject(SIGNUP_CONTACT_DETAILS);
}

export function removeContactDetails() {
  deleteFromLocalStorage(SIGNUP_CONTACT_DETAILS);
}

export function setBusinessDetails(value) {
  setObject(SIGNUP_BUSINESS_DETAILS, value);
}

export function getBusinessDetails() {
  return getObject(SIGNUP_BUSINESS_DETAILS);
}

export function removeBusinessDetails() {
  deleteFromLocalStorage(SIGNUP_BUSINESS_DETAILS);
}

export function getOnboardingStatus() {
  return getObject(ONBOARDING_STATUS);
}

export function setOnboardingStatus(obj) {
  setObject(ONBOARDING_STATUS, obj);
}

export function getSuggestedTemplate() {
  return getObject(SELECTED_SUGGESTED_TEMPLATE);
}

export function removeSuggestedTemplate() {
  deleteFromLocalStorage(SELECTED_SUGGESTED_TEMPLATE);
}

export function removeOnboardingStatus() {
  deleteFromLocalStorage(ONBOARDING_STATUS);
}

export function getPlanSubscriptionStatus() {
  return getObject(PLAN_SUBSCRIPTION_STATUS);
}

export function setPlanSubscriptionStatus(planSubscriptionStatus) {
  setObject(PLAN_SUBSCRIPTION_STATUS, planSubscriptionStatus);
}

export function getBusinessPlan() {
  return getObject(BUSINESS_PLAN) || {};
}

export function setBusinessPlan(businessPlan) {
  setObject(BUSINESS_PLAN, businessPlan);
}

export function setNonce(nonce) {
  setObject(SQ_NONCE, nonce);
}

export function getNonce() {
  return getObject(SQ_NONCE);
}

export function removeNonce() {
  deleteFromLocalStorage(SQ_NONCE);
}

export function setBillingDetails(billingDetails) {
  setObject(BILLING_DETAILS, billingDetails);
}

export function getBillingDetails() {
  return getObject(BILLING_DETAILS);
}

export function removeBillingDetails() {
  deleteFromLocalStorage(BILLING_DETAILS);
}

export function setSelectedPlan(plan) {
  setObject(SELECTED_PLAN, plan);
}

export function getSelectedPlan() {
  return getObject(SELECTED_PLAN);
}

export function removeSelectedPlan() {
  deleteFromLocalStorage(SELECTED_PLAN);
}

export function clear() {
  return localStorage.clear();
}

export function setRedeemedVoucherCode(code) {
  setObject(REDEEMED_VOUCHER_CODE, code);
}

export function getRedeemedVoucherCode() {
  return getObject(REDEEMED_VOUCHER_CODE);
}

export function setUserPlan(plan) {
  setObject(SET_USER_PLAN, plan);
}

export function getUserPlan(plan) {
  return getObject(SET_USER_PLAN, plan) || {};
}

export function setUserData(data) {
  setObject(USER_DATA, data);
}

export function getUserData() {
  return getObject(USER_DATA) || {};
}



// WEBPACK FOOTER //
// ./src/constants/localStorageManager.js